module.exports = __webpack_public_path__ + "img/new-asset-group.ce30fd63.png";